import MISReports from "./MISReports";

// ─── MIS Purchase Reports ─────────────────────────────────────────────────────
// Thin wrapper around MISReports that locks the component to purchase report
// types only. All state, fetch functions, apply logic, and JSX live in
// MISReports — this component just passes reportVariant="purchase" so the
// dropdown, defaults, and PDF export use the purchase-specific configuration.
export default function MISPurchaseReports({ connectionString, pdfString, initialReportType, openFilterTrigger }) {
    return (
        <MISReports
            connectionString={connectionString}
            pdfString={pdfString}
            initialReportType={initialReportType}
            openFilterTrigger={openFilterTrigger}
            reportVariant="purchase"
        />
    );
}
